import { render, staticRenderFns } from "./viewholdingwarrant.vue?vue&type=template&id=80fcca94"
import script from "./viewholdingwarrant.vue?vue&type=script&lang=js"
export * from "./viewholdingwarrant.vue?vue&type=script&lang=js"
import style0 from "./viewholdingwarrant.vue?vue&type=style&index=0&id=80fcca94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports